.link {
  color: var(--tuna-palette-primary-main);
  text-decoration: none;
}
